// extracted by mini-css-extract-plugin
module.exports = {"stars":"StarRating_stars__f2LfI","star":"StarRating_star__yX8VX"};